// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"376":"badb7ed7","408":"613bf03a"}[chunkId] + ".chunk.css";
};